module.exports = __webpack_public_path__ + "img/20200514_153925.f8a573a9.jpg";